import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { truncateText, capitalizeFirstLetter, handleCopy } from "../../helpers";
import NotFoundModel from "../NotFoundModel";
import { MdDelete, MdLink } from "react-icons/md";
import Tooltip from "../Tooltip";
import { IoCopySharp } from "react-icons/io5";


const Table = ({
    apiData,
    setSelectedData,
    setIsDeleteBank,
    activeTab,
    setLinkProperties
}) => {

    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);

    const [selectedRow, setSelectedRow] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    const deleteBank = (item) => {
        setIsDeleteBank(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    const linkProperties = (item) => {
        setLinkProperties(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    const ActionBtns = (item) => {
        return (
            <div className="flex items-center gap-3">
                {activeTab === "1" ?
                    <Tooltip label="Delete Bank">
                        <button
                            // title="Delete Bank"
                            onClick={() => deleteBank(item)}
                            className="p-2 rounded-full hover:bg-gray-100 transition cursor-pointer"
                        // className="text-gray-400 hover:text-gray-700 transition"
                        >
                            <MdDelete className="text-gray-400 hover:text-rose-400" size={18} />
                        </button>
                    </Tooltip>
                    :
                    <Tooltip label="Link Properties">
                        <button
                            // title="Link Properties"
                            onClick={() => linkProperties(item)}
                            className="p-2 rounded-full hover:bg-gray-100 transition cursor-pointer"
                        // className="text-gray-400 hover:text-gray-700 transition"
                        >
                            <MdLink className="text-gray-400" size={22} />
                        </button>
                    </Tooltip>}
            </div>
        );
    };

    const getStatusBadge = (isSettlement) => {
        return isSettlement ? (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                <span className="w-1.5 h-1.5 bg-green-600 rounded-full mr-1.5"></span>
                Linked
            </span>
        ) : (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                <span className="w-1.5 h-1.5 bg-red-600 rounded-full mr-1.5"></span>
                Not Linked
            </span>
        );
    };

    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                holderName: getName(item),
                branchAddress: getAddress(item),
                bankName: <Tooltip label={item?.bankAddress}>
                    {item.bankName ? item.bankName : "--"}
                </Tooltip>,
                accountNumber: item.accountNum,
                ifsc: item.ifsc,
                settlementStatus: activeTab === "2" ? getStatusBadge(item.isSettlement) : null,
                action: ActionBtns(item),
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu, activeTab]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getName = (item) => {
        return (
            <UserImageWrapper >
                <div className="flex-row flex">
                    <UserImage src={Images.Avatar} alt={`Avatar for ${item.holderName}`} />
                </div>
                <div className="flex flex-col gap-1">
                    <span className="text-gray-600 text-sm font-medium">
                        {capitalizeFirstLetter(item?.holderName)}
                        {/* {item?.holderName?.charAt(0).toUpperCase() + item?.holderName?.slice(1)}{" "} */}
                    </span>
                    <div className="flex items-center gap-1 text-xs text-gray-400">
                        <span>{'#' + item.accountNum}</span>

                        {/* {showCopy && ( */}
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                handleCopy(item.accountNum);
                            }}
                            className="hover:text-gray-600 transition"
                            title="Copy number"
                        >
                            <IoCopySharp size={12} />
                        </button>
                        {/* )} */}
                    </div>
                </div>
                {/* <div className="flex flex-col gap-1">
                    <span className="text-gray-600 text-sm font-medium">
                        {item?.holderName?.charAt(0).toUpperCase() + item?.holderName?.slice(1)}{" "}
                    </span>

                    <div className="flex gap-1">
                        <span className="text-gray-400 text-xs">#{item.accountNum}</span>
                    </div>
                </div> */}
            </UserImageWrapper>
        );
    };

    const getAddress = (item) => {
        return item.bankAddress ? (
            <div className="text-sm text-gray-600">
                <div className="flex">
                    {/* <span
                        data-tooltip-id={`tooltip-${item.id}`}
                        data-tooltip-content={item.bankAddress}
                        data-tooltip-delay-show={500}
                        data-tooltip-place="top"
                        data-tooltip-variant="info"
                        className="text-gray-600 text-sm"
                    > */}
                    <Tooltip label={item.bankAddress}>
                        {capitalizeFirstLetter(truncateText(item.bankAddress, 18))}
                    </Tooltip>
                    {/* </span> */}
                </div>

                {/* <Tooltip
                    id={`tooltip-${item.id}`}
                    className="max-w-[70%] md:max-w-[50%] xl:max-w-[40%] 2xl:max-w-[20%]"
                /> */}
            </div>
        ) : (
            "--"
        );
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {
            const mobileColumns = [
                {
                    Header: "Name & Account Number",
                    accessor: "holderName",
                },
                {
                    Header: "IFSC Code",
                    accessor: "ifsc",
                },
            ];

            // Add Settlement Status column for mobile view when activeTab === "2"
            if (activeTab === "2") {
                mobileColumns.push({
                    Header: "Status",
                    accessor: "settlementStatus",
                });
            }

            return mobileColumns;
        }

        const desktopColumns = [
            {
                Header: "Name & Account Number",
                accessor: "holderName",
            },
            {
                Header: "IFSC Code",
                accessor: "ifsc",
            },
            {
                Header: "Bank",
                accessor: "bankName",
            },
            // {
            //     Header: "Bank Address",
            //     accessor: "branchAddress",
            // },
        ];

        // Add Settlement Status column for desktop view when activeTab === "2"
        if (activeTab === "2") {
            desktopColumns.push({
                Header: "Settlement Status",
                accessor: "settlementStatus",
            });
        }

        desktopColumns.push({
            Header: "",
            accessor: "action",
        });

        return desktopColumns;
    }, [isMobileView, activeTab]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        setCurrentPage(pageIndex);
    }, [pageIndex]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th
                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                    style={column.style}
                                >
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                style={cell.column.style}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li>
                                                    <strong>Bank Name:</strong> {data[rowIndex].bankName}
                                                </li>
                                                <li>
                                                    <strong>Bank Address:</strong> {data[rowIndex].branchAddress}
                                                </li>
                                                {activeTab === "2" && (
                                                    <li>
                                                        <strong>Settlement Status:</strong> {data[rowIndex].settlementStatus}
                                                    </li>
                                                )}
                                                <li>
                                                    <strong>Action:</strong> {data[rowIndex].action}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
            {apiData?.length === 0 && <NotFoundModel />}
        </>
    );
};

const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-1 text-sm md:p-2 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2 cursor-pointer`;
const UserImage = tw.img`w-10 h-10 rounded-full `;

export default Table;